import { COMMA, ENTER } from "@angular/cdk/keycodes";
import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from "@angular/core";
import { FormGroup, FormBuilder, FormControl } from "@angular/forms"
import {
  CompanyService,
  ApiVisa
} from "blg-akaun-ts-lib";

import { AppConfig } from "../../visa";
import { SubSink } from "subsink2";

@Component({
  selector: "company-v2",
  templateUrl: "./company-v2.component.html",
  styleUrls: ["./company-v2.component.css"],
})
export class CompanyV2 implements OnInit, OnDestroy {
  @Input() companyControl = new FormControl();
  @Output() selectionChange = new EventEmitter();
  @Input() viewModelStore;
  @Input() ColumnViewActions;
  @Input() ColumnViewSelectors;
  @Input() readPermissionDefintion;


  private subs = new SubSink();
  separatorKeysCodes: number[] = [ENTER, COMMA];
  apiVisa: ApiVisa = AppConfig.apiVisa;

  allCompanies:any
  searchCompanies: any = [];
  
  form: FormGroup;


  constructor(    
    private fb: FormBuilder,
    private companyService: CompanyService,
  ) {}

  ngOnInit(): void {
      this.subs.sink = this.companyService.get(this.apiVisa).subscribe((compResponse: any) => {
        const compListing = compResponse.data.map((data, index) => ({
          name: data.bl_fi_mst_comp.name,
          code: data.bl_fi_mst_comp.code,
          guid: data.bl_fi_mst_comp.guid,
        }));
        this.allCompanies = compListing;
        this.searchCompanies = compListing
      });

  
      this.form = this.fb.group({
        companyName: new FormControl(null),
        comapnyCode:  new FormControl(null),
        selectedCompanyGuid: new FormControl(null), 
      });
  }

  onSelectCompany(company: any, event: any) {
    if (event.isUserInput) {
      console.log("Company", company)
      this.viewModelStore.dispatch(this.ColumnViewActions.setAdvanceSearch_CompanyField({ company: company }));
    }
  }


  applyCompanyNameFilter(filterValue: string) {
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // MatTableDataSource defaults to lowercase matches
    this.searchCompanies = this.allCompanies.filter((option) =>
      option.name.toLowerCase().includes(filterValue)
    );
  }


  onReset() {
    this.form.controls["companyName"].patchValue( null );
    this.form.controls["comapnyCode"].patchValue( null );
    this.form.controls["selectedCompanyGuid"].patchValue( null );
    this.viewModelStore.dispatch(this.ColumnViewActions.setAdvanceSearch_CompanyField({ company: null }));

  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }
}
